import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SearchBox } from "office-ui-fabric-react";
import React from "react";
import { Modal } from "../../../common/components";
import { gqlQuery } from "../../../common/lib";
import { GQLTrack } from "../../../schemas/schema";
import BaseComponent from "../../BaseComponent";
import { ObjectSelector, PersonSelector } from "../../ReportEditParticipants";
import { bottomSearchQueries, keyListItemSearchQuery, topSearchQueries } from "./constants";
import { IndicatorNotesTable } from "./IndicatorNotesTable";

interface IProps {
  object_type: string
  object_type_verbose: string
  object_type_verbose_plural: string
  default_track?: GQLTrack
  onAdd: (object: any) => void
  onClose: () => void
}

interface IState {
  searchQuery: any
}

export class ExistingKeyListItemModal extends BaseComponent<IProps, IState> {
  state = {
    searchQuery: {} as any
  };

  constructor(props) {
    super(props);
    if (props.default_track) {
      this.state.searchQuery.tracks = [props.default_track.id];
    }
    this.state.searchQuery.key_type = this.props.object_type;
  }

  onAdd(object) {
    window.setTimeout(() => this.props.onAdd(object), 0);
    this.props.onClose();
  }

  columns = [
    {
      name: "Date",
      key: "created_at",
      maxWidth: window.emSize() * 4,
      isDate: true,
      isSorted: true,
      isSortedDescending: true
    },
    {
      name: "Client / Company",
      key: "client_company",
      onRender: (x) => (
        <>
          {x.client.name} <br /> {x.company.name}
        </>
      ),
      minWidth: window.emSize() * 14
    },
    { name: "Impact", key: "impact", maxWidth: window.emSize() * 6 },
    { name: "Title", minWidth: window.emSize() * 26, key: "title", isMultiline: true },
    { name: "Description", minWidth: window.emSize() * 30, key: "description", isMultiline: true },
    { name: "Last Modified By", key: "last_modified_by", onRender: (x) => x.last_modified_by.full_name },
    {
      name: "Actions",
      key: "actions",
      onRender: (object) => (
        <span className="create-link">
          <a data-testid="list-add" onClick={() => this.onAdd(object)}>
            <FontAwesomeIcon icon={["fal", "plus-circle"]} />
            Add
          </a>
        </span>
      )
    }
  ];

  public render() {
    const { searchQuery } = this.state;

    const title = `Search for ${this.props.object_type_verbose_plural}`;
    const impacts = [
      { id: "low", name: "Low" },
      { id: "medium", name: "Medium" },
      { id: "high", name: "High" }
    ] as GQLObjectWithID[];

    return (
      <Modal open={true} title={title} className="existing-key-list-modal" onClose={() => this.props.onClose()}>
        <strong>Filter by:</strong>
        <div className="search top-row">
          {gqlQuery(topSearchQueries, (res) => (
            <>
              <div>
                <label>Tracks</label>
                <ObjectSelector
                  value={res.tracks.filter((x) => (searchQuery.tracks || []).indexOf(x.id) != -1)}
                  options={res.tracks}
                  onChange={(objs) => this.updateStateHash("searchQuery", { tracks: objs.map((x) => x.id) })}
                />
              </div>
              <div>
                <label>Impact</label>
                <ObjectSelector
                  value={impacts.filter((x) => (searchQuery.impacts || []).indexOf(x.id) != -1)}
                  options={impacts}
                  onChange={(objs) => this.updateStateHash("searchQuery", { impacts: objs.map((x) => x.id) })}
                />
              </div>
              <div>
                <SearchBox
                  placeholder="Title"
                  onSearch={(search) => this.updateStateHash("searchQuery", { title: search })}
                />
              </div>
              <div>
                <SearchBox
                  placeholder="Description"
                  onSearch={(search) => this.updateStateHash("searchQuery", { description: search })}
                />
              </div>
            </>
          ))}
        </div>
        <div className="search bottom-row">
          {gqlQuery(bottomSearchQueries, (res) => (
            <>
              <div>
                <label>Assessors</label>
                <PersonSelector
                  value={res.users.filter((x) => (searchQuery.users || []).indexOf(x.id) != -1)}
                  onChange={(users) => this.updateStateHash("searchQuery", { users: users.map((x) => x.id) })}
                  isMulti
                  users={res.users}
                />
              </div>
              <div>
                <label>Industry</label>
                <ObjectSelector
                  value={res.industry_groups.filter((x) => (searchQuery.industry_groups || []).indexOf(x.id) != -1)}
                  options={res.industry_groups}
                  onChange={(objs) =>
                    this.updateStateHash("searchQuery", { industry_groups: objs.map((x) => x.id) })
                  }
                />
              </div>
              <div>
                <label>Client</label>
                <ObjectSelector
                  value={res.clients.filter((x) => (searchQuery.clients || []).indexOf(x.id) != -1)}
                  options={res.clients}
                  onChange={(objs) => this.updateStateHash("searchQuery", { clients: objs.map((x) => x.id) })}
                />
              </div>
              <div>
                <label>Target Company</label>
                <ObjectSelector
                  value={res.companies.filter((x) => (searchQuery.companies || []).indexOf(x.id) != -1)}
                  options={res.companies}
                  onChange={(objs) => this.updateStateHash("searchQuery", { companies: objs.map((x) => x.id) })}
                />
              </div>
            </>
          ))}
        </div>
        <div className="table indicator-notes-table">
          <IndicatorNotesTable query={keyListItemSearchQuery} vars={searchQuery} columns={this.columns} />
        </div>
      </Modal>
    );
  }
}
